module.exports = __webpack_public_path__ + "img/compare3.5310f5d8.png";